import getFullName from "../utils/getFullName";
const ENDPOINT = process.env.REACT_APP_ENDPOINT

async function autocomplete(query, type) {
    let apiUrl = ENDPOINT
    if (type === 'MEDIA') {
        apiUrl += `/media_search/?title=${encodeURIComponent(query)}`;
    }
    else { // is actor
        apiUrl += `/actor_trigram_search/?name=${encodeURIComponent(query)}`;
    }    
    try {
        const response = await fetch(apiUrl,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const suggestions = await response.json();
        if (type === 'MEDIA') {
            return suggestions.map(s=> ({...s, name: s.title}));
        }else{
            return suggestions.map(s=> ({...s, name: getFullName(s)}));
        }
    } catch (error) {
        console.error('There was a problem with autocomplete:', error);
        return [];
    }
}

export default autocomplete;